import Select from "react-select";
import { Controller, useFormContext } from "react-hook-form";
import "./controls.scss";

interface Option {
  label: string;
  value: number;
}

interface Props {
  name: string;
  placeholder: string;
  options: Option[];
  defaultValue?: Option | null;
  value?: Option | null;
  onChange?: (selectedOption: Option | null) => void;
  required?: boolean;
  stopPropagation ?: boolean
}

export default function ESSearchDropdown(props: Props) {
  const {
    name,
    options,
    placeholder,
    defaultValue,
    value,
    required = true,
    onChange,
    stopPropagation = false, 
    ...rest
  } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors && errors[name] && errors[name]?.message;

  return (
    <>
    
      <Controller
        control={control}
        name={name}
        rules={required ? { required: `${placeholder} is required` } : {}}
        render={({ field }) => (
          <div
            onClick={(event: React.MouseEvent) => {
              if (stopPropagation) {
                event.stopPropagation();
              }
            }}
            onKeyDown={(event: React.KeyboardEvent) => {
              if (stopPropagation && (event.key === "Enter" || event.key === " ")) {
                event.stopPropagation();
              }
            }}
            tabIndex={0}
            role="presentation"
          >
            <Select
              {...rest}
              {...field}
              placeholder={placeholder}
              isClearable={true}
              options={options}
              value={field.value || defaultValue}
              onChange={(value: any) => {
                field.onChange(value);
                onChange && onChange(value);
              }}
              onBlur={field.onBlur}
              className="select-dropdown"
            />
          </div>
        )}
      />
      {typeof errorMessage === "string" && (
        <span className="text-danger">{errorMessage}</span>
      )}
    </>
  );
}
